/* nc-lp.js — campaign landing pages: scroll reveals, bundle add-to-cart
   (+ sticky bar / add-full-set triggers), copy-code chips, scroll-snap
   gallery arrows and date-scheduled blocks. */
(function () {
  'use strict';

  // Several nc-lp-* sections include this asset; run once per page.
  if (window.__ncLpLoaded) return;
  window.__ncLpLoaded = true;

  /* ---- reveal on scroll ---------------------------------- */
  function initReveals() {
    var els = document.querySelectorAll('.nc-lp [data-lp-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    // The hidden initial state only applies under .js-reveal, so content
    // stays visible when this script never runs.
    document.querySelectorAll('.nc-lp').forEach(function (root) {
      root.classList.add('js-reveal');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- bundle -------------------------------------------- */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    // 1234,56 -> 1 234,56 (thin space thousands like the shop's zł format)
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return amount + ' zł';
  }

  function openCart() {
    // Open the theme's cart drawer (assets/nc-cart-drawer.js) once it has
    // re-rendered from the post-add cart; fall back to the cart page.
    var drawer = window.NcCartDrawer;
    if (drawer && drawer.isEnabled()) {
      drawer.refresh().then(drawer.show);
      return;
    }
    window.location.href = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + 'cart'
      : '/cart';
  }

  // Applies a campaign discount to the current cart/session. Shopify sets the
  // discount on a GET to /discount/CODE; ?redirect=/cart.js keeps the follow-up
  // response ~300 B instead of pulling the full homepage (~400 KB). Never
  // rejects — a failed apply must not block the add, and the code still works
  // when typed at checkout.
  function applyDiscount(code) {
    if (!code) return Promise.resolve(null);
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
      credentials: 'same-origin'
    }).catch(function () { return null; });
  }

  // Units of one bundle row (nc-lp-bundles qty_N, e.g. "3× Kolagen"); 1 when unset.
  function itemQty(item) {
    return parseInt(item.getAttribute('data-qty'), 10) || 1;
  }

  function initBundle(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-lp-item]'));
    var cta = root.querySelector('[data-lp-add]');
    var totalEl = root.querySelector('[data-lp-total]');
    var compareRow = root.querySelector('[data-lp-compare-row]');
    var compareEl = root.querySelector('[data-lp-compare]');
    var savingRow = root.querySelector('[data-lp-saving-row]');
    var savingEl = root.querySelector('[data-lp-saving]');
    var countEl = root.querySelector('[data-lp-count]');
    var shippingEl = root.querySelector('[data-lp-shipping]');
    var errorEl = root.querySelector('[data-lp-error]');
    var freeShippingMin = parseInt(root.getAttribute('data-free-shipping-cents'), 10) || 20000;
    // Optional campaign discount code — when set, apply it after add so the
    // promo (e.g. −30%) is active on the cart. Empty → normal open-cart flow.
    var discountCode = root.getAttribute('data-lp-discount');
    // Optional promo pricing (display only): strike the full total and show
    // it after this percentage — must round per item, matching the Liquid
    // per-product prices, so the set total equals the sum of its rows.
    var promoPercent = parseInt(root.getAttribute('data-promo-percent'), 10) || 0;
    var totalCompareEl = root.querySelector('[data-lp-total-compare]');
    if (!items.length || !cta) return;

    function selected() {
      return items.filter(function (item) {
        var input = item.querySelector('input[type="checkbox"]');
        // Fixed bundle-card items (nc-lp-bundles) have no checkbox — the whole
        // set is added by one CTA — so a missing input counts as always selected.
        return !input || input.checked;
      });
    }

    function update() {
      var checked = selected();
      var total = 0;
      var compare = 0;
      items.forEach(function (item) {
        var input = item.querySelector('input[type="checkbox"]');
        // A missing checkbox (fixed bundle-card item) is always in the set.
        item.classList.toggle('is-checked', !input || input.checked);
      });
      var promoTotal = 0;
      checked.forEach(function (item) {
        var price = parseInt(item.getAttribute('data-price'), 10) || 0;
        var comparePrice = parseInt(item.getAttribute('data-compare'), 10) || price;
        var qty = itemQty(item);
        total += price * qty;
        compare += Math.max(comparePrice, price) * qty;
        promoTotal += Math.round(price * (100 - promoPercent) / 100) * qty;
      });
      var shownTotal = promoPercent > 0 ? promoTotal : total;
      if (totalEl) totalEl.textContent = formatMoney(shownTotal);
      if (totalCompareEl) {
        var showCompare = promoPercent > 0 && total > shownTotal;
        totalCompareEl.hidden = !showCompare;
        if (showCompare) totalCompareEl.textContent = formatMoney(total);
      }
      if (countEl) countEl.textContent = String(checked.length);
      var saving = compare - total;
      if (compareRow) compareRow.style.display = saving > 0 ? '' : 'none';
      if (compareEl && saving > 0) compareEl.textContent = formatMoney(compare);
      if (savingRow) savingRow.style.display = saving > 0 ? '' : 'none';
      if (savingEl && saving > 0) savingEl.textContent = '−' + formatMoney(saving);
      if (shippingEl) shippingEl.classList.toggle('is-hidden', shownTotal < freeShippingMin);
      cta.disabled = checked.length === 0;
    }

    // Each item is a <label> wrapping its checkbox, so the whole card
    // toggles natively — only the change event is needed here.
    items.forEach(function (item) {
      var input = item.querySelector('input[type="checkbox"]');
      if (input) input.addEventListener('change', update);
    });

    // `trigger` is the button that started the add: the summary CTA, or a
    // [data-lp-add-all] trigger elsewhere (sticky bar, final CTA) — its label
    // gets the loading/added feedback.
    function addToCart(trigger) {
      var checked = selected();
      if (!checked.length || trigger.classList.contains('is-loading')) return;
      var payload = checked.map(function (item) {
        return { id: parseInt(item.getAttribute('data-variant-id'), 10), quantity: itemQty(item) };
      });
      trigger.classList.add('is-loading');
      var label = trigger.querySelector('[data-lp-add-label]');
      var originalLabel = label ? label.textContent : '';
      if (label) label.textContent = trigger.getAttribute('data-loading-label') || 'Dodaję…';
      if (errorEl) errorEl.classList.remove('is-visible');

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      // Apply the code first, then add — sequentially, never in parallel: a
      // visitor with no cart yet would otherwise have /discount and /cart/add
      // each mint their own cart token and orphan one of them.
      applyDiscount(discountCode)
        .then(function () {
          return fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: payload })
          });
        })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          if (label) label.textContent = trigger.getAttribute('data-added-label') || originalLabel;
          // Theme + campaign-price listeners (see nc-product-tile.js / aov-pdp-v3.js).
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          openCart();
          window.setTimeout(function () {
            trigger.classList.remove('is-loading');
            if (label) label.textContent = originalLabel;
          }, 2500);
        })
        .catch(function () {
          trigger.classList.remove('is-loading');
          if (errorEl) errorEl.classList.add('is-visible');
          // Triggers outside the summary can't rely on its error line being
          // on screen, so they flash their own error label.
          var errorLabel = trigger.getAttribute('data-error-label');
          if (label) label.textContent = errorLabel || originalLabel;
          if (errorLabel) {
            window.setTimeout(function () {
              if (label) label.textContent = originalLabel;
            }, 2500);
          }
        });
    }

    cta.addEventListener('click', function () { addToCart(cta); });

    update();

    return {
      root: root,
      // Re-selects every item first, so the summary shows what was added.
      addAll: function (trigger) {
        items.forEach(function (item) {
          var input = item.querySelector('input[type="checkbox"]');
          if (input) input.checked = true;
        });
        update();
        addToCart(trigger);
      }
    };
  }

  /* ---- sticky add-to-cart bar ---------------------------- */
  // [data-lp-sticky] sits inside the bundle section. It shows only once the
  // whole section is above the viewport (the visitor has scrolled past the
  // offer) and hides as soon as any of it is back in view. A position check
  // on scroll rather than an IntersectionObserver: a jump straight from below
  // the offer to the top (Home key, iOS tap-to-top) never crosses the section,
  // so an observer would leave the bar showing.
  function initSticky(root) {
    var bar = root.querySelector('[data-lp-sticky]');
    if (!bar) return;
    document.body.classList.add('nc-lp-has-sticky');
    var visible = false;
    var queued = false;
    function check() {
      queued = false;
      var past = root.getBoundingClientRect().bottom < 0;
      if (past === visible) return;
      visible = past;
      bar.classList.toggle('is-visible', past);
      bar.toggleAttribute('inert', !past);
    }
    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(check);
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    check();
  }

  // [data-lp-add-all] triggers add the full set of their own bundle, or of the
  // main #lp-zestaw bundle when they sit outside one (e.g. the final CTA).
  function initAddAll(bundles) {
    if (!bundles.length) return;
    var main = bundles.filter(function (b) { return b.root.id === 'lp-zestaw'; })[0] || bundles[0];
    document.querySelectorAll('[data-lp-add-all]').forEach(function (trigger) {
      var host = trigger.closest('[data-lp-bundle]');
      var bundle = bundles.filter(function (b) { return b.root === host; })[0] || main;
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        bundle.addAll(trigger);
      });
    });
  }

  /* ---- copy discount code -------------------------------- */
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { /* unsupported */ }
    document.body.removeChild(ta);
    return ok;
  }

  function initCopyCodes() {
    document.querySelectorAll('[data-lp-copy-code]').forEach(function (btn) {
      var code = btn.getAttribute('data-lp-copy-code');
      var feedback = btn.querySelector('[data-lp-copy-feedback]');
      var originalLabel = feedback ? feedback.textContent : '';
      var timer;
      btn.addEventListener('click', function () {
        function done(ok) {
          if (!ok || !feedback) return;
          feedback.textContent = btn.getAttribute('data-copied-label') || 'Skopiowano ✓';
          btn.classList.add('is-copied');
          window.clearTimeout(timer);
          timer = window.setTimeout(function () {
            feedback.textContent = originalLabel;
            btn.classList.remove('is-copied');
          }, 2400);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            function () { done(true); },
            function () { done(fallbackCopy(code)); }
          );
        } else {
          done(fallbackCopy(code));
        }
      });
    });
  }

  // Campaign LPs send traffic to PDPs too (product tiles, chooser cards), and
  // those use the theme's own add-to-cart, which knows nothing about the code.
  // Applying it on load establishes the cart token + discount up front, so any
  // later add inherits it — wherever on the LP it happens. Opt-out per host
  // (data-lp-discount-onload="false") for store-wide codes that should only
  // land once the visitor adds the promoted product.
  function initPageDiscount() {
    var host = document.querySelector('[data-lp-discount]:not([data-lp-discount-onload="false"])');
    var code = host && host.getAttribute('data-lp-discount');
    if (code) applyDiscount(code);
  }

  /* ---- scheduled blocks (weekly gift, hero pills) -------- */
  // [data-lp-window] elements carry data-lp-from / data-lp-until (ISO with
  // offset). Liquid already hid the ones outside their window
  // (snippets/nc-lp-window.liquid), but Shopify can serve a render cached
  // across a boundary (Monday 00:00 gift swap), so the browser re-checks.
  // A [data-lp-schedule] group always shows exactly one child: the first in
  // its window, else the latest one already started, else the first.
  // ?lp_now=2026-11-10T12:00:00+01:00 previews another moment (QA).
  function scheduleNow() {
    var match = /[?&]lp_now=([^&]+)/.exec(window.location.search);
    var t = match ? Date.parse(decodeURIComponent(match[1])) : NaN;
    return isNaN(t) ? Date.now() : t;
  }

  function windowState(el, now) {
    var from = Date.parse(el.getAttribute('data-lp-from') || '');
    var until = Date.parse(el.getAttribute('data-lp-until') || '');
    // NaN (no bound) compares false both ways, so a blank end stays open.
    return { started: !(from > now), on: !(from > now) && !(until <= now) };
  }

  function initSchedules() {
    var now = scheduleNow();
    document.querySelectorAll('.nc-lp [data-lp-schedule]').forEach(function (group) {
      var items = Array.prototype.slice.call(group.querySelectorAll('[data-lp-window]'));
      if (!items.length) return;
      var pick = null;
      var started = null;
      items.forEach(function (el) {
        var state = windowState(el, now);
        if (state.on && !pick) pick = el;
        if (state.started) started = el;
      });
      pick = pick || started || items[0];
      items.forEach(function (el) { el.hidden = el !== pick; });
    });
    document.querySelectorAll('.nc-lp [data-lp-window]').forEach(function (el) {
      if (el.closest('[data-lp-schedule]')) return;
      el.hidden = !windowState(el, now).on;
    });
  }

  // Theme editor: selecting a scheduled block shows it, whatever the date.
  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-lp-window')) return;
    var group = el.closest('[data-lp-schedule]');
    if (group) {
      group.querySelectorAll('[data-lp-window]').forEach(function (item) { item.hidden = item !== el; });
    }
    el.hidden = false;
    el.querySelectorAll('[data-lp-reveal]').forEach(function (node) { node.classList.add('is-in'); });
    if (el.hasAttribute('data-lp-reveal')) el.classList.add('is-in');
  });

  /* ---- scroll-snap galleries: arrow buttons ------------- */
  // Markup: [data-lp-gallery] > [data-lp-gallery-track] (the snap row) and
  // buttons with data-lp-gallery-dir="-1|1". Scrolls by one card.
  function initGalleries() {
    document.querySelectorAll('[data-lp-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-lp-gallery-track]');
      if (!track) return;
      gallery.querySelectorAll('[data-lp-gallery-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = track.firstElementChild;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          var step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
          var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({
            left: step * parseInt(btn.getAttribute('data-lp-gallery-dir'), 10),
            behavior: smooth ? 'smooth' : 'auto'
          });
        });
      });
    });
  }

  function init() {
    // Before the reveals: hidden blocks must not be observed as visible ones.
    initSchedules();
    initReveals();
    initGalleries();
    initCopyCodes();
    initPageDiscount();
    var bundles = [];
    document.querySelectorAll('[data-lp-bundle]').forEach(function (root) {
      var bundle = initBundle(root);
      if (bundle) bundles.push(bundle);
      initSticky(root);
    });
    initAddAll(bundles);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
